import {inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {NavigationEnd, Router} from '@angular/router';
import {distinctUntilChanged, filter, map, startWith} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class LorenNavService {
    private router = inject(Router);

    private sidenavToggleStateChange: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private sidenavControl: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

    routerUrl$ =  this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        map((event: NavigationEnd) => event.urlAfterRedirects),
    );
    inAdminApp$ = this.routerUrl$.pipe(
        map((url: string) => url.startsWith('/admin/')),
        startWith(false),
        distinctUntilChanged(),
    )

    public setSidenavToggleStateChanged(state: boolean) {
        this.sidenavToggleStateChange.next(state);
    }

    public onSidenavToggleStateChanged(): Observable<boolean> {
        return this.sidenavToggleStateChange.asObservable();
    }

    public sidenavControl$(): Observable<boolean> {
        return this.sidenavControl.asObservable();
    }

    public toggleSidenav(state: boolean) {
        this.sidenavControl.next(state);
    }
}
